// extracted by mini-css-extract-plugin
module.exports = {"stageToggler":"StageToggler_stageToggler__1h1C9","prev":"StageToggler_prev__2Lhxh","next":"StageToggler_next__ULGzA"};